import { useOrganization } from "@clerk/clerk-react";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import FormField from "../atoms/FormField";
import FormSelect from "../atoms/FormSelect";
import FileUploadField from "../molecules/FileUploadField";

/**
 * IntakeForm - Form for creating new tasks
 *
 * @param {Object} props
 * @param {Function} props.onSubmit - Form submission handler
 * @param {boolean} props.isSubmitting - Whether form is submitting
 */
const IntakeForm = forwardRef(({ onSubmit, isSubmitting = false }, ref) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [assigneeId, setAssigneeId] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);

  const { organization } = useOrganization();

  // Expose handleSubmit method to parent component
  useImperativeHandle(ref, () => ({
    handleSubmit: () => {
      // Call parent's onSubmit with form data
      onSubmit({
        title,
        description,
        assigneeId,
        selectedFiles,
      });
    },
    resetForm: () => {
      setTitle("");
      setDescription("");
      setAssigneeId("");
      setSelectedFiles([]);
    },
  }));

  // Create options for assignee dropdown
  const assigneeOptions = [
    { value: "", label: "Unassigned" },
    ...(organization?.memberships?.map((membership) => ({
      value: membership.publicUserData.userId,
      label: `${membership.publicUserData.firstName} ${membership.publicUserData.lastName}`,
    })) || []),
  ];

  return (
    <div className="space-y-4">
      <FormField
        id="title"
        label="Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        placeholder="Task title"
        required
      />

      <FormField id="description" label="Description" className="col-span-2">
        <textarea
          id="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="w-full p-2 border border-[#2f3236] rounded focus:ring-[#4db1e0] focus:border-[#4db1e0] bg-[#262b30] text-gray-200"
          placeholder="Task description"
          rows={4}
        />
      </FormField>

      <FormSelect
        id="assignee"
        label="Assignee"
        value={assigneeId}
        onChange={(e) => setAssigneeId(e.target.value)}
        options={assigneeOptions}
      />

      <FileUploadField
        id="file"
        label="Attachments"
        selectedFiles={selectedFiles}
        onChange={setSelectedFiles}
        multiple
      />
    </div>
  );
});

export default IntakeForm;
